import { Configuration, OpenAIApi } from "openai";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setImage } from "../../redux/image";
import Refresh from "../../images/icons/refresh";
import {
  increaseImageGenerationCount,
  setDishImage,
  setOldDishImage,
  setRecipeAllImage,
} from "../../redux/title";
import { extractDishTitle } from "../../utils/extractTitle";
import { Progress, Spinner, Tooltip } from "@nextui-org/react";
import { generateImageService } from "../../utils/apiServices/openAIServices";
import { Dark_White_mode } from "../../utils/constants";

export default function GenerateImageRecipe({
  prompt,
  disheSinglePage = false,
  isRecipeDetailsFindVariantTriggered = false,
}) {
  const dispatch = useDispatch();
  const [imageChangeUser, setImageChangeUser] = useState(false);

  const { image } = useSelector((state) => state.image);
  const { dishNumber, images, imageGenerationCount, recipeAllImage } =
    useSelector((state) => state.title);

  const { plan: subScriptionPlan, isActive: subscriptionStatus } = useSelector(
    (state) => state.tokens
  );

  const [loading, setLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState(
    "Search Bears with Paint Brushes the Starry Night, painted by Vincent Van Gogh.."
  );

  const generateImage = async () => {
    try {
      setPlaceholder(`Search ${prompt}..`);
      setLoading(true);
      let title = extractDishTitle(prompt, 2);
      const promptForImage = disheSinglePage
        ? `Give me a professional food commercial image of ${title} plated and set against an appropriate backdrop. No Text. Focus mainly on the dish`
        : prompt;
      // const promptForImage = `Give me a professional food commercial image of ${title} plated and set against an appropriate backdrop. No Text. Focus mainly on the dish`
      const res = await generateImageService(promptForImage, "medium");
      setLoading(false);
      dispatch(setImage(res));
      if (dishNumber > 0 && dishNumber < 4) {
        dispatch(
          setDishImage({
            dishNumber,
            url: res,
          })
        );
        dispatch(
          setRecipeAllImage({
            dishNumber,
            url: res,
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const shouldGenerateImage = () => {
    if (images?.[dishNumber]) {
      return false;
    } else {
      return true;
    }
  };
  useEffect(() => {
    if (prompt) {
      if (disheSinglePage) {
        if (shouldGenerateImage()) {
          generateImage();
        } else {
          dispatch(setImage(images?.[dishNumber]));
        }
      } else {
        // generateImage();
      }
    }
  }, [prompt]);

  useEffect(() => {
    if (!disheSinglePage && shouldGenerateImage()) {
      generateImage();
    }
  }, []);

  useEffect(() => {
    if (isRecipeDetailsFindVariantTriggered > 0 && shouldGenerateImage()) {
      generateImage();
    }
  }, [isRecipeDetailsFindVariantTriggered]);

  useEffect(() => {
    console.log(recipeAllImage?.[dishNumber]?.indexOf(image));
  }, [image]);

  console.log("recipeAllImage", recipeAllImage, image);
  const changeImageToDisplay = (index) => {
    dispatch(setImage(recipeAllImage?.[dishNumber][index]));
    dispatch(
      setDishImage({
        dishNumber,
        url: recipeAllImage?.[dishNumber][index],
      })
    );
    setImageChangeUser(true);
    setTimeout(() => {
      setImageChangeUser(false);
    }, 2000);
  };

  return (
    <div className="app-main w-full flex flex-col justify-center items-center">
      {loading ? (
        <>
          {/* <LinearProgress
            variant="indeterminate"
            title="test"
            // classes={{ bar: classes.bar }}
            style={{
              width: "70%",
              marginRight: "4px",
              color: "white",
              marginTop: "30px",
              backgroundColor: "white"
            }}
          /> */}
          <Progress
            isIndeterminate
            aria-label="Loading..."
            className="w-[80%] mx-auto  mt-8"
            size="sm"
            classNames={{
              indicator: "bg-red-400",
            }}
          />
          {/* </div> */}
        </>
      ) : (
        <>
          {image?.length > 0 && prompt ? (
            <>
              <div div className="relative">
                <img
                  // className="result-image rounded-lg w-[512px] h-[512px]"
                  className="result-image rounded-lg md:max-w-[512px] md:max-h-[512px] max-w-full"
                  src={image}
                  alt="result"
                />
                {imageChangeUser && (
                  <Spinner className="absolute top-1/2 left-1/2" />
                )}
                {subscriptionStatus && (
                  <Tooltip
                    content={
                      subScriptionPlan === "Basic" ||
                      subScriptionPlan === "Free"
                        ? "Upgrade to Explorer or Foodie Membership generate new image"
                        : "Click here to generate new image"
                    }
                    placement="top"
                  >
                    <div
                      className={
                        "absolute bottom-[-5px] right-[-11px] bg-slate-200 rounded p-2 flex items-center gap-2"
                      }
                      onClick={() => {
                        // if (
                        //   imageGenerationCount < 3 &&
                        //   subScriptionPlan !== "Basic" &&
                        //   subScriptionPlan !== "Free"
                        // ) {
                        dispatch(increaseImageGenerationCount());
                        generateImage();
                        // }
                      }}
                    >
                      <Refresh
                        fill={imageGenerationCount == 3 ? "#777778" : "#F44378"}
                        className={`w-4 h-4 ${
                          imageGenerationCount == 3
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                        } `}
                      />
                      {imageGenerationCount > 0 && (
                        <p style={{ fontSize: "10px" }}>
                          {`${imageGenerationCount} / 3`}
                        </p>
                      )}
                    </div>
                  </Tooltip>
                )}
              </div>
              {recipeAllImage?.[dishNumber]?.length > 1 && (
                <div className="flex items-center gap-2 mt-4">
                  <Tooltip
                    content={"Click here to select old images"}
                    placement="top"
                  >
                    <p className={`${Dark_White_mode} text-md`}>Prev Images</p>
                  </Tooltip>
                  {recipeAllImage?.[dishNumber]?.map((item, index) => (
                    <p
                      className={`text-sm cursor-pointer ${
                        item === image && "text-red-500"
                      }`}
                      onClick={() => changeImageToDisplay(index)}
                    >
                      {index + 1}
                    </p>
                  ))}
                </div>
              )}
            </>
          ) : null}
        </>
      )}
    </div>
  );
}
